import { render, staticRenderFns } from "./DayaDukungBannerChartPie.vue?vue&type=template&id=1941f929&scoped=true"
import script from "./DayaDukungBannerChartPie.vue?vue&type=script&lang=js"
export * from "./DayaDukungBannerChartPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941f929",
  null
  
)

export default component.exports